<template>
  <ModalComponent
    name="rejectApprovalModal"
    width="500"
    height="auto"
    :adaptive="true"
    :click-to-close="true"
    @before-close="modalClosed"
  >
    <div
      v-if="dataApproval"
      class="flex flex-col justify-between px-5 py-3"
    >
      <div class="flex justify-between">
        <h2 class="flex items-center gap-x-1.5 text-xl font-semibold text-gray-900 lg:text-lg">
          <span>Confirmation required</span>
        </h2>
        <button
          class="flex h-8 w-8 items-center justify-center rounded-md bg-[#EEEFF0D4] text-[#808080] outline-none"
          @click="$modal.hide('rejectApprovalModal')"
        >
          <TimesSmall />
        </button>
      </div>
      <div class="flex flex-col items-start w-full gap-2 mb-10">
        <p class="text-sm">
          Are you sure you want reject this submission?
        </p>
        <!-- removing this field for now until we re-release this feature in the near future -->
        <!-- <textarea-input v-model="rejectMessage" placeholder="Please provide clear reason(s) for the rejection to assist the Data Owner in making the necessary corrections" /> -->
      </div>
      <div class="flex justify-end gap-2 pt-2 border-t-2">
        <GhostButton @click="closeModal">
          Cancel
        </GhostButton>
        <PrimaryButton @click="submitButtonClicked">
          Yes, continue
        </PrimaryButton>
      </div>
    </div>
    <div
      v-else
      class="flex flex-col justify-between py-10 px-7"
    >
      <div class="flex justify-between mb-4">
        <h2 class="flex items-center gap-x-1.5 text-xl font-semibold text-gray-900 lg:text-lg">
          <span>Rejection Message</span>
        </h2>
        <button
          class="flex h-8 w-8 items-center justify-center rounded-md bg-[#EEEFF0D4] text-[#808080] outline-none"
          @click="$modal.hide('rejectApprovalModal')"
        >
          <TimesSmall />
        </button>
      </div>
      <div class="flex flex-col items-start w-full gap-2 mb-7">
        <tip-tap-input
          ref="tiptapEditor"
          :is-modal-mode="true"
          :mentionable-users="users"
        />
      </div>
      <div class="flex justify-end gap-2 border-t-2 pt-7">
        <GhostButton
          class="px-6 text-cancel-green"
          @click="handleCancel"
        >
          Cancel
        </GhostButton>
        <PrimaryButton
          :disabled="$refs.tiptapEditor?.isEmpty"
          class="px-6"
          @click="handleSubmit"
        >
          Submit
        </PrimaryButton>
      </div>
    </div>
  </ModalComponent>
</template>

<script>
export default {
  name: 'RejectApprovalModal',

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    users: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['submit-rejection', 'modal-closed', 'selected-users'],

  data() {
    return {
      rejectMessage: '',
      dataApproval: false,
      messageInputRef: null,
      taggedUserIds: [],
    }
  },

  watch: {
    isOpen(val) {
      if (val) {
        this.$modal.show('rejectApprovalModal')
      }
    },
  },

  methods: {
    submitButtonClicked() {
      this.$emit('selected-users', this.taggedUserIds)
      this.$emit('submit-rejection', this.rejectMessage)
      this.rejectMessage = ''
      this.$modal.hide('rejectApprovalModal')
    },
    closeModal() {
      this.$modal.hide('rejectApprovalModal')
    },
    modalClosed() {
      this.$emit('modal-closed')
    },
    handleSubmit() {
      const taggedUsers = Array.from(this.$refs.tiptapEditor.selectedUsers)
      const content = this.$refs.tiptapEditor.editor.getHTML()
      this.$refs.tiptapEditor.saveButtonClicked()
      this.$emit('selected-users', taggedUsers)
      this.$emit('submit-rejection', content)
      this.closeModal()
    },
    handleCancel() {
      this.$refs.tiptapEditor.cancelButtonClicked()
      this.closeModal()
    },
  },
}
</script>
